<script setup>
import { reactive, watch } from "vue";
import { AisInfiniteHits } from "vue-instantsearch/vue3/es";
import { useRoute } from "vue-router";
import ResultsWrapper from "../Display/ResultsWrapper.vue";
import MyStudentsFilterSummary from "../MyStudentsFilterSummary.vue";
import MyStudentsResultsSort from "../MyStudentsResultsSort.vue";
import MyStudentsSearch from "../MyStudentsSearch.vue";
import MyStudentsAcceptanceList from "./MyStudentsAcceptanceList.vue";
import SelectableStatusCard from "./SelectableStatusCard.vue";

import { ACCEPTANCE_STATUS, getAcceptanceStatusIcon } from "./utils";

const route = useRoute();

const statusList = () => {
  return Object.values(ACCEPTANCE_STATUS).map((v) => {
    return { label: v };
  });
};

const adjustments = reactive({
  [ACCEPTANCE_STATUS.readyForReview]: 0,
  [ACCEPTANCE_STATUS.accepted]: 0,
  [ACCEPTANCE_STATUS.notAccepted]: 0,
  [ACCEPTANCE_STATUS.provisionallyAccepted]: 0,
  [ACCEPTANCE_STATUS.conditionallyAccepted]: 0,
});

const adjustTotals = (newStatus, oldStatus) => {
  Object.values(ACCEPTANCE_STATUS).forEach((s) => {
    if (s === newStatus) {
      adjustments[newStatus] = adjustments[newStatus] + 1;
    } else if (s === oldStatus) {
      adjustments[oldStatus] = adjustments[oldStatus] - 1;
    }
  });
};

const resetAdjustments = () => {
  Object.values(ACCEPTANCE_STATUS).forEach((s) => {
    adjustments[s] = 0;
  });
};

// Reset only when the user actually leaves the acceptance page; previously this watched the
// whole route object, which fired on every search/refinement keystroke (each routing.write()
// runs router.replace) and silently zeroed the in-progress acceptance count adjustments.
watch(() => route.params.page, resetAdjustments);
</script>

<template>
  <div class="flex flex-col p-[1rem] w-full">
    <div class="flex w-full overflow-y-auto md:overflow-hidden">
      <selectable-status-card
        page="acceptances"
        attribute="order.core.host_accepted_status"
        query-attribute="acceptance_status"
        :schema="statusList()"
        :iconLookupFunction="getAcceptanceStatusIcon"
        :adjustments="adjustments"
        @algolia-updated="resetAdjustments"
      />
    </div>
    <div class="flex ml-auto w-full md:w-1/3 mt-4">
      <my-students-search data-testid="my-students-acceptance-search" />
    </div>
    <div class="flex flex-col md:flex-row justify-between py-4">
      <div class="flex flex-grow">
        <!-- TODO include this component in my students filter summary and test if its still working-->
        <my-students-filter-summary />
      </div>
      <div class="flex flex-1 md:flex-none justify-between">
        <my-students-results-sort data-testid="my-students-acceptance-results-sort" />
      </div>
    </div>
    <div>
      <results-wrapper>
        <ais-infinite-hits>
          <template v-slot="{ items, refineNext, isLastPage }">
            <my-students-acceptance-list
              :orders="items"
              :refine-next="refineNext"
              :is-last-page="isLastPage"
              @update-totals="adjustTotals"
            />
          </template>
        </ais-infinite-hits>
      </results-wrapper>
    </div>
  </div>
</template>
